/* ========== 対象処理 ========== */
// 1. 会員登録 / 移行用メール送信
//
// 会員登録
// 2. 仮会員情報表示（メールアドレス）
// 3. 入力内容確認欄表示
// 4. 本会員登録
//
// 会員移行
// 2. 会員情報表示
// 3. 入力内容確認欄表示
// 4. 本会員登録

document.addEventListener("DOMContentLoaded", function () {
  const sendRegisterEmailButton = document.getElementById('send_register_email_button');
  const sendMigrateEmailButton = document.getElementById('send_migrate_email_button');
  const registerAccountArea = document.getElementById('register_area');
  const migrateAccountArea = document.getElementById('migrate_area');
  const getSmsButton = document.getElementById('get_sms_register');
  const getIvrButton = document.getElementById('get_ivr_register');
  const confirmAccountButton = document.getElementById('confirm_account_button');
  const registerAccountButton = document.getElementById('register_account_button');
  const migrateAccountButton = document.getElementById('migrate_account_button');
  const registerMailArea = document.getElementById('register_mail_area');
  const authCode = document.getElementsByName('auth_code');
  const mailRegisterForm = document.getElementById("mail_register_form");
  const mailMigrateForm = document.getElementById("mail_migrate_form");

  /* ========== 会員登録 ========== */
  // 会員登録用メール送信
  if (sendRegisterEmailButton) {
    mailRegisterForm.addEventListener("submit", (e) => {
      e.preventDefault();
      sendRegisterEmail(sendRegisterEmailButton, SEND_MAIL_TYPE.NORMAL);
    });
  }

  // 会員登録ページ
  if (registerAccountArea) {
    // 仮会員情報表示
    setPreCustomer(registerAccountArea, ACTIVATE_STATUS.PROVISIONAL_NEW);

    let furigana = document.querySelector('.furigana');
    changeLang(furigana);

    //sms送信ボタン
    const register_phone_form = document.getElementById('register_phone_form');
    if(getSmsButton){
      register_phone_form.addEventListener("submit", (e) => {
        e.preventDefault();
        getSmsAuthCode(getSmsButton);
      });
    }

    if(getSmsButton){
      // IVR認証へのリンク表示
      displayIvrAuthLink();

      // IVR認証モーダルの表示
      const modal = document.querySelector('.wl-modal');
      const ivrModal = document.querySelector('#ivr-modal-button');
      const closeModelImg = document.querySelector('#close-modal-img');
      ivrModal.addEventListener('click', (e) => {
        // モーダルを開く
        modal.classList.add('display-modal');
      });

      modal.addEventListener('click', (e) => {
        // モーダル外側をクリックされた時
        if (!e.target.closest('#verification__prompt')) {
          closeIvrModal();
        }
      });
      closeModelImg.addEventListener('click', (e) => {
        closeIvrModal();
      });
    }

    // IVR送信ボタン
    const register_ivr_form = document.getElementById('register_ivr_form');
    if(getIvrButton){
      register_ivr_form.addEventListener("submit", (e) => {
        e.preventDefault();
        getSmsAuthCode(getIvrButton, 0);
      });
    }

    // 確認ボタン
    const register_input_form = document.getElementById("register_input_form");
    if(confirmAccountButton){
      //郵便番号バリデーション
      setAddress();

      register_input_form.addEventListener("submit", (e) => {
        e.preventDefault();
        confirmCustomer();
      });
    }

    // 登録ボタン
    registerAccountButton.addEventListener("click", () => {
      const url = `${APP_PROXY_URL}/api/customer`;
      registerCustomer(url, registerAccountButton);
    });

    //認証番号入力イベント
    authCode.forEach(function(code){
      code.addEventListener('input', function(){
        checkField(this);
      })
      code.addEventListener('keyup', function(){
        nextField(this);
      })
    })
  }

  // メールアドレス受付完了ページ
  if (registerMailArea) {
    registerEmailMail(registerMailArea);
  }

  /* ========== 会員移行 ========== */
  // 会員移行用メール送信
  if (sendMigrateEmailButton) {
    mailMigrateForm.addEventListener("submit", (e) => {
      e.preventDefault();
      sendRegisterEmail(sendMigrateEmailButton, SEND_MAIL_TYPE.MIGRATE);
    });
  }

  // 会員移行ページ
  if (migrateAccountArea) {
    // inputに移行会員情報設定
    setPreCustomer(migrateAccountArea, ACTIVATE_STATUS.PROVISIONAL_MIGRATION);
    let furigana = document.querySelector('.furigana');
    changeLang(furigana);

    //sms送信ボタン
    const register_phone_form = document.getElementById('register_phone_form');
    if(getSmsButton){
      register_phone_form.addEventListener("submit", (e) => {
        e.preventDefault();
        getSmsAuthCode(getSmsButton);
      });
    }

    if(getSmsButton){
      // IVR認証へのリンク表示
      displayIvrAuthLink();

      // IVR認証モーダルの表示
      const modal = document.querySelector('.wl-modal');
      const ivrModal = document.querySelector('#ivr-modal-button');
      const closeModelImg = document.querySelector('#close-modal-img');
      console.log(true)
      ivrModal.addEventListener('click', (e) => {
        // モーダルを開く
        modal.classList.add('display-modal');
      });

      modal.addEventListener('click', (e) => {
        // モーダル外側をクリックされた時
        if (!e.target.closest('#verification__prompt')) {
          closeIvrModal();
        }
      });
      closeModelImg.addEventListener('click', (e) => {
        closeIvrModal();
      });
    }

    // IVR送信ボタン
    const register_ivr_form = document.getElementById('register_ivr_form');
    if(getIvrButton){
      register_ivr_form.addEventListener("submit", (e) => {
        e.preventDefault();
        getSmsAuthCode(getIvrButton, 0);
      });
    }

    // 確認ボタン
    const register_input_form = document.getElementById("register_input_form");
    if(confirmAccountButton){
      //郵便番号バリデーション
      setAddress();

      register_input_form.addEventListener("submit", (e) => {
        e.preventDefault();
        confirmCustomer();
      });
    }

    // 移行ボタン
    migrateAccountButton.addEventListener("click", () => {
      const url = `${APP_PROXY_URL}/api/customer/migration_info`;
      migrateCustomer(url, migrateAccountButton);
    });

    //認証番号入力イベント
    authCode.forEach(function(code){
      code.addEventListener('input', function(){
        checkField(this);
      })
      code.addEventListener('keyup', function(){
        nextField(this);
      })
    })
  }

});

// 会員登録用メール送信
const sendRegisterEmail = async (sendEmailButton, mailType) => {
  const url = `${APP_PROXY_URL}/api/register_email`;
  let successMessage = document.getElementById('success_send_message');
  let errorMessage = document.getElementById('error_send_message');
  successMessage.innerText = '';
  errorMessage.innerText = '';
  errorMessage.style.display = "none";
  btnLoading(sendEmailButton);

  const params = validateRegisterEmail(mailType);
  if (!params) {
    btnStopLoading(sendEmailButton);
    return;
  }

  const res = await fetchPostMethod(url, params);

  if (res.message == 'ok') {
    const token = random();
    window.location.href = `https://${location.hostname}/pages/email_register_mail?token=${token}`;
  } else {
    if(res.message == undefined){
      errorMessage.innerText = 'サーバーエラーが発生しました';
    }else{
      errorMessage.innerText = res.message;
    }
    errorMessage.style.display = "block";
    btnStopLoading(sendEmailButton);
  }
};

//メールアドレス受付完了表示
const registerEmailMail = async (registerMailArea) => {
  let errorMessage = document.getElementById('error_message');

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');

  if (!token) {
    for(i = 0; i < registerMailArea.childElementCount; i++){
      registerMailArea.children[i].style.display = 'none';
    }

    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    errorMessage.style.display = "block";
    return;
  }
};

// 登録メールアドレスページ表示
// type: 0 仮会員, 1 移行会員
const setPreCustomer = async (parent, status) => {
  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');

  if (!token) {
    checkHasToken(parent);
    return;
  }

  const url = new URL(`${APP_PROXY_URL}/api/pre_customer`);
  url.searchParams.set('token', token);
  url.searchParams.set('status', status);

  const customer = await getPreCustomer(url.href);

  if (!customer) {
    checkHasToken(parent);
    return;
  }

  if (status === ACTIVATE_STATUS.PROVISIONAL_NEW) {
    // 仮会員登録情報表示（メールアドレスのみ）
    setRegisterPreCustomerFields(customer);
  } else {
    setMigratePreCustomerFields(customer);
  }
};

// 仮会員登録情報設定
const setRegisterPreCustomerFields = (customer) => {
  let email = document.querySelector('.--mail ._customerData');
  email.innerText = customer.email;
};

// 移行会員登録情報設定
const setMigratePreCustomerFields = (customer) => {
  let email = document.querySelector('.--mail ._customerData');
  let lastName = document.querySelector('._name input[name=lastName]');
  let firstName = document.querySelector('._name input[name=firstName]');
  let lastKana = document.querySelector('._name input[name=lastKana]');
  let firstKana = document.querySelector('._name input[name=firstKana]');
  let country = document.querySelector('.c-select select.country');
  let postalCode = document.querySelector('._postcode input[name=postalCode]');
  let prefecture = document.querySelector('.c-select select.prefectures');
  let countyCityAddress = document.querySelector('input[name=countyCityAddress]');
  let townAddress = document.querySelector('input[name=townAddress]');
  let buildingName = document.querySelector('input[name=buildingName]');
  let phoneNumber = document.querySelector('input[name=phoneNumber]');
  let birthday = document.querySelectorAll('._birthday select');

  email.innerText = customer.email;
  lastName.value = customer.lastName;
  firstName.value = customer.firstName;
  lastKana.value = customer.lastKana;
  firstKana.value = customer.firstKana;
  country.value = customer.country;
  townAddress.value = customer.townAddress;
  buildingName.value = customer.buildingName;
  phoneNumber.value = customer.phoneNumber;
  birthday[0].value = customer.birthYear;
  birthday[1].value = customer.birthMonth;
  birthday[2].value = customer.birthDay;

  if (customer.countyCityAddress !== ' ') {
    countyCityAddress.value = customer.countyCityAddress;
  }

  if (customer.country === 'JP') {
    postalCode.value = customer.postalCode;
    prefecture.value = customer.prefecture;
  } else {
    setEditAddress();
  }

  // 性別
  setEditSex(customer.sex);

  // DMを受け取る
  setEditDM(customer.shopDM);

  // 関心あるブランド
  if (customer.brandinterestlist !== null && customer.brandinterestlist.length > 0) {
    setEditBlandList(customer.brandinterestlist);
  }
};

// 登録内容確認
const confirmCustomer = async () => {
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';
  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');
  if(!token) {
    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    return;
  }

  const params = validateRegisterCustomer(token);
  if (!params) {
    errorMessage.innerText = '入力内容に不備があります';
    errorMessage.style.display = "block";
    return;
  }else{
    errorMessage.style.display = "none";
  }

  setNextField();
  setConfirmCustomer(params);
};

// 会員登録
const registerCustomer = async (url, registerAccountButton) => {
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';
  btnLoading(registerAccountButton);

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');
  if(!token) {
    btnStopLoading(registerAccountButton);
    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    return;
  }

  const params = validateRegisterCustomer(token, VIP_STATUS.NORMAL);
  if (!params) {
    setBackField();
    btnStopLoading(registerAccountButton);
    return;
  }

  const res = await fetchPostMethod(url, params);
  if (res.message == 'ok') {
    window.location = getMultipassUrl(res.multipassToken);
  } else {
    if (res.error) {
      res.message = 'サーバーエラーが発生しました';
    }
    if (res.errors){
      const ignoreError = ['token', 'type'];
      setServerValidationError(res.errors, ignoreError);
    }

    if(res.detailCode == 401006){
      const smsAuthInput = document.querySelector('input[name=auth_code]');
      displayErrorMessage(smsAuthInput.parentNode, res.message);
      res.message = '入力内容に不備があります';
    }else if(res.detailCode == 409004){
      const phoneNumber = document.querySelector('input[name=phoneNumber]');
      displayErrorMessage(phoneNumber, res.message);
      res.message = '入力内容に不備があります';
    }

    setBackField(res.message);
    btnStopLoading(registerAccountButton);
  }
};

// 移行処理
const migrateCustomer = async (url, migrateAccountButton) => {
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';
  btnLoading(migrateAccountButton);

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');
  if(!token) {
    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    btnStopLoading(migrateAccountButton);
    return;
  }

  const params = validateRegisterCustomer(token);
  if (!params) {
    setBackField();
    btnStopLoading(migrateAccountButton);
    return;
  }

  const res = await fetchPutMethod(url, params);
  if (res.message == 'ok') {
    window.location = getMultipassUrl(res.multipassToken);
  } else {
    if (res.error) {
      res.message = 'サーバーエラーが発生しました';
    }
    if (res.errors){
      const ignoreError = ['token'];
      setServerValidationError(res.errors, ignoreError);
    }

    if (res.detailCode == 401006) {
      const smsAuthInput = document.querySelector('input[name=auth_code]');
      displayErrorMessage(smsAuthInput.parentNode, res.message);
      res.message = '入力内容に不備があります';
    } else if (res.detailCode == 409004){
      const phoneNumber = document.querySelector('input[name=phoneNumber]');
      displayErrorMessage(phoneNumber, res.message);
      res.message = '入力内容に不備があります';
    }

    setBackField(res.message);
    btnStopLoading(migrateAccountButton);
  }
};

// 登録内容確認ページ表示
const setConfirmCustomer = (customer) => {
  let mainInfo = document.querySelectorAll('.main_info ._customerData');
  let lang = WOVN.io.getCurrentLang().code;

  mainInfo[0].innerText = document.querySelector('.--mail ._customerData').innerText;
  mainInfo[2].innerText = `${customer.lastName} ${customer.firstName}`;
  let furigana = document.querySelector('.main_info .furigana');
  if(lang == 'ja'){
    mainInfo[3].innerText = `${customer.lastKana} ${customer.firstKana}`;
    // furigana.style.display = 'flex';
  }else{
    furigana.style.display = 'none';
  }
  mainInfo[4].innerText = setCountry(customer);

  let postcode = document.querySelector('.main_info .f-postcode');
  let prefectures = document.querySelector('.main_info .f-prefectures');
  if (customer.country == 'JP') {
    mainInfo[5].innerText = customer.postalCode;
    mainInfo[6].innerText = customer.prefecture;
    // postcode.style.display = 'flex';
    // prefectures.style.display = 'flex';
  } else {
    postcode.style.display = 'none';
    prefectures.style.display = 'none';
  }
  mainInfo[7].innerText = customer.countyCityAddress;
  mainInfo[8].innerText = customer.townAddress;
  mainInfo[9].innerText = customer.buildingName;
  mainInfo[10].innerText = customer.phoneNumber;
  mainInfo[11].innerText = setSex(customer);
  mainInfo[12].innerText = setBirthday(customer);
  setNewsletter(customer, mainInfo[13]);
  mainInfo[14].innerText = setShopDM(customer);
  setBlandList(customer, mainInfo[15]);
};

const setAddress = () => {
  var isJapanPostalCodeLoaded = false;
    if(!isJapanPostalCodeLoaded){
      // ZipCode AutoFill
      if (typeof JapanPostalCode !== 'undefined') {
        const options = {
          name: 'register',
          messages: {
            addressExists: "住所が正しくありません",
            addressTownExists: "郵便番号に基づいた住所をご登録ください。ご入力いただいた住所の表記を再度ご確認ください。例）〇 三番町 × 3番町",
          }
        };

        // Add New Address
        new JapanPostalCode(
          {
            container: '#register_input_container',
            form: '#register_input_form',
            buttonSubmit: '#confirm_account_button',
            country: '[name="country"]',
            zipCode: '[name="postalCode"]',
            city: '[name="countyCityAddress"]',
            province: '[name="province"]',
            address01: '[name="townAddress"]',
            address02: '[name="buildingName"]',
            firstName: '[name="firstName"]',
            lastName: '[name="lastName"]',
            firstNameKana: '[name="firstKana"]',
            lastNameKana: '[name="lastKana"]',
            phone: '[name="phoneNumber"]',
          },
          options
        );
      }

      isJapanPostalCodeLoaded = true;
    }
}